<template>
  <div class="specific-people-info-container">
    <h2 class="people-headings">Children</h2>
    <div
      v-for="child in relations.children"
      :key="'Child' + child.id"
      class="person-info"
    >
      <p>{{ child.fullName }}</p>
    </div>

    <p v-if="!relations.children.length" class="person-info">
      You have not added any children
    </p>
    <div class="card-button-container no-border">
      <FunkButton button-text="Edit" @buttonClicked="editChildren" />
    </div>

    <div v-if="testator.hasChildren">
      <v-divider class="my-4" />

      <h2 class="people-headings">Children guardian(s)</h2>
      <div
        v-for="guardian in relations.guardians"
        :key="'Guardian' + guardian.id"
        class="person-info"
      >
        <p>{{ guardian.fullName }}</p>
      </div>

      <p v-if="!relations.guardians.length" class="person-info">
        You have not added any child guardians
      </p>
      <div class="card-button-container no-border">
        <FunkButton button-text="Edit" @buttonClicked="editGuardians" />
      </div>

      <v-divider v-if="showTrusts" class="my-4" />

      <div v-if="showTrusts">
        <h2 class="people-headings">Trustees</h2>
        <div v-if="testator.createChildrensTrust">
          <div
            v-for="trustee in relations.trustees"
            :key="'Trustee' + trustee.id"
            class="person-info"
          >
            <p>{{ trustee.fullName }}</p>
          </div>
          <div v-if="testator.companyIsTrustee" class="person-info">
            <p>{{ testator.company.trustCompanyName }}</p>
          </div>
        </div>

        <p v-else>You have not added a trust</p>
        <div class="card-button-container no-border">
          <FunkButton button-text="Edit" @buttonClicked="editTrustees" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ChildrenOverview',
    props: {
      testator: {
        type: Object,
        required: true,
      },
      relations: {
        type: Object,
        required: true,
      },
    },
    computed: {
      showTrusts() {
        return this.testator.willCountry != 'GB';
      },
    },
    methods: {
      editChildren() {
        this.$router.push({
          name: 'Children',
          query: { peopleWizard: 'children' },
        });
      },
      editGuardians() {
        this.$router.push({
          name: 'ChildrensGuardian',
          query: { peopleWizard: 'guardians' },
        });
      },
      editTrustees() {
        this.$router.push({
          name: 'ChildrensTrust',
          query: { peopleWizard: 'trust' },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../constants/styles/people-overview-info-blocks.scss';
</style>
